import '../../assets/table.css'; 
import { FiEdit2, FiInfo } from 'react-icons/fi';
import UpdateStatusModal from './updateStatusModal';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import * as additionalPaymentActions from '../../Redux/Actions/additionalPayments';
import { toastMessage } from '../../utils/toast';
import AdditionalPaymentDocumentModal from './additionalPaymentDocumentModal';
import { dateTimeFormat } from '../../utils';
import AdditionalPaymentReferenceModal from './additionalPaymentReferenceModal';
import { BsInfoCircleFill } from 'react-icons/bs';
import AdditionalPaymentLogs from './additionalPaymentLogs';
import CONFIG from '../../config';

const AdditionalPayment = ({ t, additionalPaymentInfo, updateStatus, jobID }) => {

    const [updateStatusModal, setUpdateStatusModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [paymentId, setPaymentId] = useState();
    const [additionalPaymentDocumentModal, setAdditionalPaymentDocumentModal] = useState(false);
    const [additionalPaymentAttachment, setAdditionalPaymentAttachment] = useState('');
    const [additionalPaymentReferenceModal, setAdditionalPaymentReferenceModal] = useState(false);
    const [paymentReferenceInfo, setPaymentReferenceInfo] = useState({});
    const [additonalPaymentLogs, setAdditionalPaymentLogs] = useState(false);
    const [apId, setApId] = useState(0);
    const [statusLogId, setStatusLogId] = useState(0);
    const [permissonRoles, setPermissonRoles] = useState(["SUPERADMIN"]);

    const userData = useSelector(({ User }) => User.data);

    useEffect(() => {
        if(CONFIG.enableEditInAdditionalPaymentForSubadmin === 'true') {
            const roles = [...permissonRoles, "SUBADMIN"];
            setPermissonRoles(roles);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUpdateStatus = (payload) => {
        setLoading(true);
        additionalPaymentActions.updateStatus(payload).then((res) => {
            if(res?.status === 200) {
                toastMessage('success', 'Status updated successfully!');
                window.location.reload();
            } else {
                toastMessage('errpr', 'Unable to update status!');
            }
            setLoading(false);
            setUpdateStatusModal(false);
        }).catch((res) => {
            toastMessage('error', res.response?.data?.Message || "Unable to update status!");
            setLoading(false);
            setUpdateStatusModal(false);
        })
    }

    const handleSubmitReference = (payload) => {
        setLoading(true);
        additionalPaymentActions.updateAdditionalPaymentReference(payload).then(res => {
            if(res?.status === 200) {
                toastMessage('success', 'Updated reference successfully!');
                window.location.reload();
            }
            setLoading(false);
            setAdditionalPaymentReferenceModal(false);
        }).catch((err) => {
            setLoading(false);
            setAdditionalPaymentReferenceModal(false);
            toastMessage('error', 'Unable to update reference status!');
        })
    }

    return (
        <div className="card card-custom card-stretch gutter-b">
            <div className="card-body pb-3">
                <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.additionalPayment.title")}</h3>
                <div className="d-flex mt-2">
                    {(additionalPaymentInfo?.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : <div className="table-responsive">
                        <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                            <thead>
                                <tr className="text-left">
                                    <th className="pl-7" style={{width: '50px'}}>{t("jobsManagement.infoJob.additionalPayment.sNo")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.name")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.status")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.referenceStatus")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.referenceNumber")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.chargeableAmount")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.electronicFee")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.serviceFee")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.totalAmount")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.reason")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.approvedBy")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.approvedDate")}</th>
                                    <th className="text-center">{t("additionalPayments.statusLogs")}</th>
                                    <th className='text-center'>{t("jobsManagement.infoJob.additionalPayment.action")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {additionalPaymentInfo?.map(({ id, typeName, additionalPaymentTypeDescription, serviceFee, totalAmount, status, referenceNumber, additionalPaymentReference, chargeableAmount, electronicFee, reason, additionalPaymentAttachment, approvedById, approvedBy, approvedTime }, index) => {
                                    return (
                                    <tr key={index}>
                                        <td className="pl-7">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index+1}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{additionalPaymentTypeDescription ? `${typeName} (${additionalPaymentTypeDescription})` : typeName}</span>
                                        </td>
                                        <td className="text-center" style={{whiteSpace: 'nowrap'}}>
                                            <span className={"p-2 badge badge-outline-" + (status === 'Pending' ? "warning" : (status === 'Approved' || status === 'Completed') ? "success" : status === "Paid" ? "info" : "danger")} style={{borderRadius: '3px', width: 'auto'}} >
                                                {status}
                                            </span>
                                        </td>
                                        <td className="text-center d-flex justify-content-center align-items-center" style={{whiteSpace: 'nowrap'}}>
                                            { additionalPaymentReference === null ? <span className="text-dark-75 font-weight-bolder d-block font-size-lg my-1">{"NA"}</span> : 
                                                <>
                                                    <span className={"p-2 badge badge-outline-" + (additionalPaymentReference?.status === 'Pending' ? "warning" : additionalPaymentReference?.status === 'Approved' ? "success" : "danger")} style={{borderRadius: '3px', width: 'auto'}} >
                                                        { additionalPaymentReference?.status }
                                                    </span>
                                                    <FiEdit2 className="mx-2" onClick={() => {setAdditionalPaymentReferenceModal(true); setPaymentReferenceInfo(additionalPaymentReference); setApId(id)}}/>
                                                </>
                                            }
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{referenceNumber}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{chargeableAmount}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{electronicFee}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{serviceFee}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{totalAmount}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{reason ? reason: '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{approvedById ? approvedBy?.name: '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{approvedById ? dateTimeFormat(approvedTime): '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <BsInfoCircleFill onClick={() => {setAdditionalPaymentLogs(true); setStatusLogId(id)}}/>                                        
                                        </td>
                                        <td className="text-center">
                                            { (status === 'Pending' && permissonRoles?.includes(userData.Role)) ? <FiEdit2 onClick={() => { setUpdateStatusModal(true); setPaymentId(id)}}/> : null }
                                            <FiInfo className="mx-2" onClick={() => {setAdditionalPaymentDocumentModal(true); setAdditionalPaymentAttachment(additionalPaymentAttachment)}}/>
                                        </td>
                                    </tr>
                                    )})}
                            </tbody>
                        </table>
                    </div>}
                </div>
            </div>
            { updateStatusModal && 
                <UpdateStatusModal 
                    t={t}
                    paymentId={paymentId}
                    updateStatus={updateStatus}
                    loading={loading}
                    showModal={updateStatusModal}
                    handleCancel={() => setUpdateStatusModal(false)}
                    handleOk={(payload) => handleUpdateStatus(payload)}
                />
            }
            { additionalPaymentDocumentModal && 
                <AdditionalPaymentDocumentModal 
                    t={t}
                    showModal={additionalPaymentDocumentModal}
                    handleClose={() => setAdditionalPaymentDocumentModal(false)}
                    additionalPaymentAttachment={additionalPaymentAttachment}
                />
            }
            { additionalPaymentReferenceModal &&
                <AdditionalPaymentReferenceModal 
                    t={t}
                    id={apId}
                    loading={loading}
                    showModal={additionalPaymentReferenceModal}
                    handleClose={() => {setAdditionalPaymentReferenceModal(false); setApId(0)}}
                    additionalPaymentInfo={additionalPaymentInfo}
                    handleOk={(payload) => handleSubmitReference(payload)}
                    paymentReferenceInfo={paymentReferenceInfo}
                    permissonRoles={permissonRoles}
                />
            }
            { additonalPaymentLogs &&
                <AdditionalPaymentLogs 
                    t={t}
                    id={statusLogId}
                    showModal={additonalPaymentLogs}
                    handleClose={() => setAdditionalPaymentLogs(false)}  
                />
            }
        </div>
    );
};

export default AdditionalPayment;